export default "__VITE_ASSET__CR99562v__"